import { defineStore } from 'pinia'
import { services } from '@/assets/js/config.js';
import { useHttpStore } from './httpStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export const useApprovalStore = defineStore('approval', {
  state: () => ({
		activeApprovalList:[]
  }),
  getters: {
	},
  actions: {
		getAprovalList(params={}) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.invinity}approval`, params).then((resp) => {
          httpStore.convertPaginationKeys(resp.data);
					this.activeApprovalList = resp.data.data
          resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },
		
    createApproval(params) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.post(`${services.invinity}approval`, params).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

    updateApproval(id, params) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.put(`${services.invinity}approval/${id}`, params).then((resp) => {
					resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },
		
    deleteApproval(id) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.delete(`${services.invinity}approval/${id}`).then((resp) => {
					resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },
  }
})